import Repository from "./Repository"

const URL_INPUT_OTP = "/otps/input"
const URL_GET_STATUS_OTP = "/otps/status"
const URL_CANCEL_OTP = "/otps/cancel"

export default {
    inputOtp(payload) {
        return Repository.post(URL_INPUT_OTP, payload)
    },
    getStatusOTP(payload) {
        return Repository.get(URL_GET_STATUS_OTP, payload)
    },
    cancelOTP(payload) {
        return Repository.put(URL_CANCEL_OTP, payload)
    }
}
